import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "m14 22 8-18a6 6 0 0 1 6 6v8h11.32a4 4 0 0 1 4 4.6l-2.76 18a4 4 0 0 1-4 3.4H14m0-22v22m0-22H8a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h6m0-22v22H8a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4zm0 0v22H8a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14 44V22H8a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4z"
    }, null, -1)
  ])))
}
export default { render: render }